import fails$1 from './fails.js';

var fails = fails$1;
var functionBindNative = !fails(function () {
  var test = function () {
    /* empty */
  }.bind(); // eslint-disable-next-line no-prototype-builtins -- safe


  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

export { functionBindNative as default };
